import React, { useState } from 'react';
const CEDRINE_PINK = 'https://cdn.magicpatterns.com/uploads/d1UxJwMnw1VtaPYmuTpHux/ComfyUI_00011_.png';
interface FanFic {
  id: string;
  title: string;
  rating: string;
  content: React.ReactNode;
}
const FAN_FICS: FanFic[] = [{
  id: 'fic1',
  title: 'Cedrine the Queen of the World',
  rating: 'PG',
  content: <div className="space-y-4 text-base" data-id="element-50">
        <p className="font-bold italic" data-id="element-51">Chapter 1: The Coronation</p>
        <p data-id="element-52">
          The crystal palace shimmered in the pink sunlight. Princess Cedrine
          stood on the balcony, her diamond microphone in hand. Today was the
          day she would become Queen of Earthia.
        </p>
        <p data-id="element-53">
          "People of Earthia!" she sang, and her voice was so beautiful that all
          the birds stopped flying just to listen. "I promise to rule with love,
          sparkles, and amazing pop anthems!"
        </p>
        <p data-id="element-54">
          Suddenly, the sky turned dark. The evil Lord Tone-Deaf had arrived to
          steal her voice! But Cedrine just hit a high C note and his dark magic
          shattered into a million glittery pieces.
        </p>
        <p className="text-sm text-gray-500 mt-4" data-id="element-55">
          (A/N: Plz review!!! Chapter 2 coming soon if I get 5 reviews!!!)
        </p>
      </div>
}, {
  id: 'fic2',
  title: 'A Dance of Song: Cedrine Defeats the Dragon Prince',
  rating: 'PG-13 for fantasy violence',
  content: <div className="space-y-4 text-base" data-id="element-56">
        <p data-id="element-57">
          The Dragon Prince roared, breathing green fire across the stage.
          Cedrine didn't even flinch. She just adjusted her headset mic and
          started the choreography for "Unstoppable Heart".
        </p>
        <p data-id="element-58">
          With every spin, a wave of pure pop energy hit the dragon.{' '}
          <em data-id="element-59">BAM!</em> A pirouette knocked him back. <em data-id="element-60">POW!</em> A perfect
          vocal run made his scales fall off.
        </p>
        <p data-id="element-61">"You can't defeat me!" the Dragon Prince yelled.</p>
        <p data-id="element-62">
          "Watch me," Cedrine smirked, and signaled the backup dancers to
          initiate the final chorus attack.
        </p>
      </div>
}, {
  id: 'fic3',
  title: 'Emmy & Cedrine, best friends that could have been',
  rating: 'G (Based on a REAL dream I had!!!)',
  content: <div className="space-y-4 text-base" data-id="element-63">
        <p data-id="element-64">
          I was just walking through the mall, minding my own business, when I
          bumped into someone. "Oh my gosh, I'm so sorry!" I said.
        </p>
        <p data-id="element-65">
          I looked up and I literally couldn't breathe. It was CEDRINE DION.
        </p>
        <p data-id="element-66">
          "No, it's my fault," she said with her perfect smile. "Hey, I love
          your outfit. Do you want to come backstage at my concert tonight and
          be my new best friend?"
        </p>
        <p data-id="element-67">
          "YES!" I screamed. We went to Claire's and bought matching BFF
          necklaces and then she let me sing backup on her biggest hit. It was
          the best day ever.
        </p>
      </div>
}];
export function FanFictionSection() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section id="fanfic" className="w-full max-w-3xl mx-auto mb-12" data-id="element-68">
      <div className="bg-[#e6e6fa] retro-border-double p-6 retro-shadow" data-id="element-69">
        <h2 className="text-3xl md:text-4xl text-center text-[#660066] mb-4" style={{
        textShadow: '1px 1px 0px #fff'
      }} data-id="element-70">
          ~*~ FAN FICTION CORNER ~*~
        </h2>

        {/* Photo of Cedrine for ~inspiration~ */}
        <div className="text-center mb-6" data-id="element-71">
          <img src={CEDRINE_PINK} alt="Cedrine being an absolute ICON" className="mx-auto w-40 h-40 object-cover rounded-full border-4" style={{
          borderStyle: 'double',
          borderColor: '#9370db',
          borderWidth: '6px'
        }} data-id="element-72" />
          <p className="text-xs text-[#8b008b] mt-1 italic" data-id="element-73">
            ~*~ My muse, my inspiration ~*~
          </p>
        </div>

        <div className="text-center mb-6 text-sm font-bold text-red-700 bg-red-100 p-2 border border-red-300" data-id="element-74">
          ⚠️ WARNING: DO NOT STEAL MY STORIES!!! I WILL FIND OUT AND REPORT YOU
          TO ANGELFIRE!!! 🛑
        </div>

        <div className="grid gap-6" data-id="element-75">
          {FAN_FICS.map(fic => <div key={fic.id} className="bg-white border-2 border-[#9370db] p-5 shadow-[4px_4px_0px_#9370db]" data-id="element-76">
              <h3 className="text-xl md:text-2xl text-[#4b0082]" data-id="element-77">
                {fic.title}
              </h3>
              <div className="text-xs text-gray-600 mb-4 bg-gray-100 p-1 inline-block mt-1" data-id="element-78">
                Rated: {fic.rating} | Author: Emmy (CedrineLuvr4eva)
              </div>

              {expandedId === fic.id ? <div className="bg-[#f8f8ff] p-4 border border-dashed border-[#9370db]" data-id="element-79">
                  {fic.content}
                  <button onClick={() => setExpandedId(null)} className="mt-4 text-[#ff1493] hover:text-[#0000ff] underline font-bold text-base" data-id="element-80">
                    [Close Story]
                  </button>
                </div> : <div data-id="element-81">
                  <div className="italic text-gray-500 mb-2 text-base" data-id="element-82">
                    Preview...
                  </div>
                  <button onClick={() => setExpandedId(fic.id)} className="bg-[#9370db] text-white px-4 py-1.5 border-2 border-black hover:bg-[#ff1493] font-bold text-base" data-id="element-83">
                    Read Story &gt;&gt;
                  </button>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}